<template>
  <naj-box
    :title="basicInfoLocal.activities.title"
    no-gutters
  >
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <info-list
      v-else
      :form-model="activities"
      :headers="headers"
    ></info-list>
  </naj-box>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import InfoList from '@/modules/bankruptcy/components/bankruptcy-file/info-list.vue';
import { toHijriDate } from '@/helpers/utils';

export default {
  name: 'Activities',
  components: { InfoList },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      toHijriDate,
      basicInfoLocal: this.local.bankruptcy.bankruptcyFile.basicInfo,
      activities: {},
      headers: [
        {
          key: 'activities',
          text: this.local.bankruptcy.activitiesForm.activities,
        },
        {
          key: 'activitiesStatus',
          text: this.local.bankruptcy.activitiesForm.activitiesStatus,
          formatter: (val) => { return val ? this.local.bankruptcy.activitiesForm.active : this.local.bankruptcy.activitiesForm.inActive; },
        },
        {
          key: 'activitiesStartDate',
          text: this.local.bankruptcy.activitiesForm.activitiesStartDate,
          formatter: (val) => { return this.toHijriDate(val) || '---'; },
        },
        {
          key: 'activitiesEndDate',
          text: this.local.bankruptcy.activitiesForm.activitiesEndDate,
          formatter: (val) => { return this.toHijriDate(val) || '---'; },
        },
        {
          key: 'numberBranches',
          text: this.local.bankruptcy.activitiesForm.numberBranches,
        },
        {
          key: 'capital',
          text: this.local.bankruptcy.activitiesForm.capital,
        },
        {
          key: 'numberCreditors',
          text: this.local.bankruptcy.activitiesForm.numberCreditors,
        },
        {
          key: 'totalDebt',
          text: this.local.bankruptcy.activitiesForm.totalDebt,
        },
        {
          key: 'numberDebtors',
          text: this.local.bankruptcy.activitiesForm.numberDebtors,
        },
        {
          key: 'totalRights',
          text: this.local.bankruptcy.activitiesForm.totalRights,
        },
        {
          key: 'numberEmployees',
          text: this.local.bankruptcy.activitiesForm.numberEmployees,
        },
        {
          key: 'totalAsset',
          text: this.local.bankruptcy.activitiesForm.totalAsset,
        },
        {
          key: 'moneyStoragePlace',
          text: this.local.bankruptcy.activitiesForm.moneyStoragePlace,
          size: 12,
          disableSplit: true,
        },
        {
          key: 'overviewDebtorFinancialPosition',
          text: this.local.bankruptcy.activitiesForm.overviewDebtorFinancialPosition,
          size: 12,
          disableSplit: true,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.loading = true;
    this.getActivities(this.requestObjectKey)
      .then((res) => {
        this.activities = res.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: { ...mapActions(['getActivities']) },
};
</script>

<style lang="scss" scoped>
</style>
